// 🔹 검색 페이지 전용: "최근 검색어" 렌더링
window.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('recommendKeywordContainer');
  if (!container) return;

  // 🍪 쿠키 가져오기
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  // 🍪 쿠키 저장 / 업데이트
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${date.toUTCString()};path=/;domain=.worksout.com;Secure;SameSite=Lax`;
  }

  // 🍪 쿠키 업데이트용
  function updateCookie(keywords) {
    setCookie('recentKeywords', JSON.stringify(keywords), 7);
  }

  // 🔸 최근 검색어 렌더링 함수
  function renderRecentKeywords() {
    const cookieVal = getCookie('recentKeywords');
    if (!cookieVal) {
      container.innerHTML = '<p class="empty-keyword-msg">No recent searches.</p>';
      container.classList.remove('loading');
      return;
    }

    let keywords = [];
    try {
      keywords = JSON.parse(cookieVal);
    } catch (e) {}

    if (!Array.isArray(keywords) || keywords.length === 0) {
      container.innerHTML = '<p class="empty-keyword-msg">No recent searches.</p>';
      container.classList.remove('loading');
      return;
    }

    // ✅ HTML 출력
    container.innerHTML = keywords
      .map(
        kw => `
          <div class="ab-recommend-keyword-item">
            <a href="/search?q=${encodeURIComponent(kw)}">${kw}</a>
            <button class="keyword-remove" data-keyword="${kw}" aria-label="Delete">×</button>
          </div>
        `
      )
      .join('');

    // ❌ X 버튼 클릭 시 쿠키 갱신 및 재렌더링
    container.querySelectorAll('.keyword-remove').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const target = e.currentTarget.dataset.keyword;
        const updated = keywords.filter(k => k !== target);
        updateCookie(updated);
        renderRecentKeywords();
      });
    });

    // ✅ 최종 렌더 완료 후 로딩 제거
    container.classList.remove('loading');
  }

  // 🔸 블록 데이터 유무 확인 (Liquid에서 data-has-blocks로 전달)
  const hasBlockData = container.dataset.hasBlocks === 'true';

  // 🔹 블록이 없을 때만 쿠키 기반 렌더링
  if (!hasBlockData) {
    // 살짝 지연을 줘서 깜빡임 방지 (0.1초)
    setTimeout(() => {
      renderRecentKeywords();
    }, 100);
  } else {
    // 블록 데이터가 있을 경우에도 로딩 상태 제거
    container.classList.remove('loading');
  }
});
